"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Title = ({ text }) => {
    return (react_1.default.createElement("div", { className: "mt-7 md:mt-12" },
        react_1.default.createElement("h2", { className: "mb-2 font-sans text-[calc(1.425rem+2.1vw)] font-normal text-neutral-600 xl:text-5xl" }, text)));
};
exports.default = Title;
